import type { JSX } from 'react'
import type { ITextBlockHeadlineExtra5Footnote2Props } from 'blocks/TextBlock/Templates'
import type { IGeoblockErrorScreenProps } from '../GeoblockErrorScreen'

import { TextBlockHeadlineExtra5Footnote2 } from 'blocks/TextBlock/Templates'
import { GeoblockErrorScreen } from '../GeoblockErrorScreen'
import { GeoblockErrorScreenPaddings } from '../GeoblockErrorScreen.h'

export interface IGeoblockErrorScreenTemplateProps extends Omit<
  IGeoblockErrorScreenProps,
  'children'
> {
  title?: ITextBlockHeadlineExtra5Footnote2Props['title']
  description?: ITextBlockHeadlineExtra5Footnote2Props['description']
}

export const GeoblockErrorScreenTemplate = ({
  title = '',
  description = '',
  padding = GeoblockErrorScreenPaddings.SIZE_10,
  ...rest
}: IGeoblockErrorScreenTemplateProps): JSX.Element => (
  <GeoblockErrorScreen padding={padding} {...rest}>
    <TextBlockHeadlineExtra5Footnote2 title={title} description={description} />
  </GeoblockErrorScreen>
)
